import { render, staticRenderFns } from "./GenerateGridForStageTournament.vue?vue&type=template&id=4c9c28c2&scoped=true"
import script from "./GenerateGridForStageTournament.vue?vue&type=script&lang=js"
export * from "./GenerateGridForStageTournament.vue?vue&type=script&lang=js"
import style0 from "./GenerateGridForStageTournament.vue?vue&type=style&index=0&id=4c9c28c2&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4c9c28c2",
  null
  
)

export default component.exports